import { graphql } from '@contra/relay';

// The only reason this fragment are in a separate file and not in the AppPreload
// component file is because we wanted to name the fragment `CurrentUser` for
// the convenience of easy identification. Otherwise fragments really should be in
// the component files. - @erictaylor
export const currentUserFragment = graphql`
  fragment CurrentUser on UserAccount {
    id
    calendarLink
    emailAddress
    createdAt
    posthogId
    analyticsUserId
    isTestAccount
    selectedUserType
    signupSource
    intercomUserHash
    userInterfaceFlags
    profile {
      membershipRequestedAt
      organizationV2 {
        id
        name
        slug
      }
      locationGooglePlaceId
      location
      id
      avatarImage {
        id
        uid
        url
      }
      isRemovedFromClientWorkspace
      title
      id
      bio
      firstName
      lastName
      displayUsername
      onboardingType
      professionalTitle
      analyticsId
      independentPortfolioTemplateTheme {
        id
      }
      analytics {
        id
      }
      hasActivePortfolioSubscription
      ...AvatarImageFragment
    }
    userFeatures
    userGroups
    waitLists {
      edges {
        node {
          id
          nid
        }
      }
    }
    workspaceForSelectedUserType {
      __typename
      id
      enabledFeatures
      name
      visitorMember {
        id
        enabledFeatures
      }
      members {
        count
      }
      ... on ClientWorkspace {
        clientMembershipRequest {
          hasRequestedMembership
          advancedSearchPreviewStartedAt
          hasRequestedAdvancedSearchPreview
          hasScheduledACall
        }
        activeSubscription {
          nid
          status
          trialRemainingDays
          createdAt
        }
      }
    }
    workspaces {
      __typename
      visitorMember {
        enabledFeatures
      }
    }
  }
`;
